import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import Close from 'icons/button_close.svg'

export const Wrap = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: ${calculateResponsiveSize(20)};
    left: ${calculateResponsiveSize(122)};
    right: ${calculateResponsiveSize(122)};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${calculateResponsiveSize(20)};
    padding: ${calculateResponsiveSize(17)} ${calculateResponsiveSize(20)};
    font-size: ${calculateResponsiveSize(14)};
    color: #ffffff;
    line-height: 1.4;
    border-radius: 12px;
    background: rgba(62, 43, 46, 0.8);
    opacity: 0;
    visibility: hidden;
    transition: opacity 1s;
    z-index: 49;
  }
  &.show {
    .cookies-banner {
      opacity: 1;
      visibility: visible;
    }
  }
  .cookies-banner-accept-btn {
    display: none;
  }
  body.hero-rotated & .cookies-banner {
    opacity: 0;
    visibility: hidden;
  }
  ${mediaMax('mobile')} {
    .cookies-banner {
      bottom: 0;
      left: 0;
      right: 0;
      gap: 0;
      padding: ${calculateMobileResponsiveSize(5)} 0 ${calculateMobileResponsiveSize(10)};
      font-size: ${calculateMobileResponsiveSize(12)};
      line-height: 1.6;
      border-radius: 0;
      background: rgba(32, 33, 36, 0.80);
      backdrop-filter: blur(10px);
    }
  }
`

export const Content = styled.div`
  display: flex;
  ${mediaMax('mobile')} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${calculateMobileResponsiveSize(10)};
    width: ${calculateMobileResponsiveSize(240)};
    text-align: center;
  }
`

export const Buttons = styled.div`
  display: flex;
  gap: ${calculateResponsiveSize(11)};
  margin-left: ${calculateResponsiveSize(40)};
  & a.learn-more {
    color: white;
    border: 1px solid white;
    background: transparent;
    @media (any-hover: hover) {
      &:hover {
        color: var(--Terracotta);
        background: white;
        border: 1px solid white;
        & .arrow {
          background: var(--Terracotta);
        }
      }
    }
  }
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(10)};
    margin: 0;
  }
`

export const ButtonClose = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(15)};
  width: ${calculateResponsiveSize(26)};
  height: ${calculateResponsiveSize(26)};
  transform: translateY(-50%);
  background: url(${Close}) center center no-repeat;
  background-size: ${calculateResponsiveSize(24)};
  transition: background-size 0.25s;
  cursor: pointer;
  &:hover {
    background-size: ${calculateResponsiveSize(26)};
  }
  ${mediaMax('mobile')} {
    top: ${calculateMobileResponsiveSize(10)};
    right: ${calculateMobileResponsiveSize(10)};
    width: ${calculateMobileResponsiveSize(20)};
    height: ${calculateMobileResponsiveSize(20)};
    transform: translateY(0);
    background-size: ${calculateMobileResponsiveSize(18)};
    &:hover {
      background-size: ${calculateMobileResponsiveSize(20)};
    }
  }
`
